import React, {useState} from 'react'
import {useTranslation} from "react-i18next";
import Card from "@mui/material/Card";
import {useDispatch, useSelector} from "react-redux";
import Grid from "@mui/material/Grid";
import moment from "moment-timezone";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Collapse from '@mui/material/Collapse';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Tooltip from "@mui/material/Tooltip";
import {onErrorAlert, onSuccessAlert} from "../../actions";
import {asnWmsProcessStateArr, getInboundOrderStatusArr, getOrderStatusArr} from "../../constants";

const InboundDetail = ({info,loading}) => {

    const {t} = useTranslation()
    const [isOpen,setIsOpen] = useState(true)
    const dispatch = useDispatch()
    const hangStatusList = [
        {
            id: 1,
            value: 'N',
            label: `NO`
        },
        {
            id: 2,
            value: 'Y',
            label: `YES`
        },
        {
            id: 3,
            value: null,
            label: `-`
        },
    ]



    const executeStatusArr = [
        {
            id: 1,
            value: '0',
            label: `Unexecuted`
        },
        {
            id: 2,
            value: '10',
            label: `Partially Executed`
        },
        {
            id: 3,
            value: '20',
            label: `Execution Completed`
        },
        {
            id: 3,
            value: '30',
            label: `Execution Error`
        },
    ]

    const receivedStateArr = [
        {
            id: 1,
            value: "0",
            label: `Unreceived`
        },
        {
            id: 2,
            value: '20',
            label: `Receipt completed`
        },
    ]
    const businessTypeArr = [
        {
            id: 1,
            value: "WHOLESALE_ASN",
            label: `Wholesale`
        },
        {
            id: 2,
            value: 'SHOPEC_ASN',
            label: `E-commerce`
        },

    ]

    const ASNArr = getInboundOrderStatusArr(t);

    const handleClickCopy = (textToCopy) => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    dispatch(onSuccessAlert(`"${textToCopy}" ${t('copied')}`))
                })
                .catch((err) => {
                    dispatch(onErrorAlert(`${t('copy failed')}`))
                });
        }

    };

    const convertTime = (date)=>{
        let serverTime = moment.tz(date, "America/Toronto")
        // const localTimezone = moment.tz.guess();
        // const localTime = serverTime.clone().tz(localTimezone);
        // console.log("localTimezone",localTimezone)
        // console.log("localTime",localTime)
        // console.log("return",moment(serverTime).local().format('MM/DD/YYYY HH:mm'))
        return  moment(serverTime).local().format('YYYY-MM-DD HH:mm')
    }
    return(<React.Fragment>
        <Card  sx={{minWidth: 250}}>
            <MDBox
                mx={1}
                mt={-3}
                py={1}
                px={2}
                variant="gradient"
                bgColor="light"
                borderRadius="lg"
                coloredShadow="light"
                display={'flex'}
                alignItems={'center'}
                justifyContent={'space-between'}

            >
                <MDTypography variant="h6">
                    {t('InboundPage.Inbound Basic Information')}
                </MDTypography>
                <IconButton size={'small'} disabled={loading} onClick={()=>setIsOpen(!isOpen)}>
                    {(isOpen && !loading)?<Icon>expand_less</Icon>:<Icon>expand_more</Icon>}
                </IconButton>
            </MDBox>
            <Collapse in={isOpen && !loading} timeout={500}>
                <MDBox pt={1} pb={2} px={2}>
                    <Grid container xs={12} display="flex" p={0} m={0}>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('InboundPage.Execute ASN No.')}:
                                </MDTypography>
                                <Tooltip title={t("Copy")} placement={'right'} onClick={()=> handleClickCopy(info?.applyAsnNo)}>
                                    <IconButton aria-label="copy" size="small" color="primary">
                                        <ContentCopyIcon fontSize="small"/>
                                    </IconButton>
                                </Tooltip>

                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.applyAsnNo}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        {/*<Grid item mb={1} xs={12} md={6} lg={2.4}>*/}
                        {/*    <MDBox>*/}
                        {/*        <MDTypography variant="button" fontWeight="medium" gutterBottom >*/}
                        {/*            {t('InboundPage.OMS ASN No.')}:*/}
                        {/*        </MDTypography>*/}
                        {/*        {info?.omsAsnNo && info?.omsAsnNo!=='NOT PROVIDED' &&<Tooltip title={t("Copy")} placement={'right'} onClick={()=> handleClickCopy(info?.omsAsnNo)}>*/}
                        {/*            <IconButton aria-label="copy" size="small" color="primary">*/}
                        {/*                <ContentCopyIcon fontSize="small"/>*/}
                        {/*            </IconButton>*/}
                        {/*        </Tooltip>}*/}
                        {/*    </MDBox>*/}
                        {/*    <MDBox>*/}
                        {/*        <MDTypography variant="button" color="text" fontWeight="regular">*/}
                        {/*            {info?.omsAsnNo}*/}
                        {/*        </MDTypography>*/}
                        {/*    </MDBox>*/}
                        {/*</Grid>*/}
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('InboundPage.OMS Execute ASN No.')}:
                                </MDTypography>
                                {info?.omsExAsnNo && info?.omsExAsnNo!=='NOT PROVIDED' &&<Tooltip title={t("Copy")} placement={'right'} onClick={()=> handleClickCopy(info?.omsExAsnNo)}>
                                    <IconButton aria-label="copy" size="small" color="primary">
                                        <ContentCopyIcon fontSize="small"/>
                                    </IconButton>
                                </Tooltip>}
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.omsExAsnNo}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('InboundPage.From Order No.')}:
                                </MDTypography>
                                {info?.fromOrderNo && info?.fromOrderNo!=='NOT PROVIDED' &&<Tooltip title={t("Copy")} placement={'right'} onClick={()=> handleClickCopy(info?.fromOrderNo)}>
                                    <IconButton aria-label="copy" size="small" color="primary">
                                        <ContentCopyIcon fontSize="small"/>
                                    </IconButton>
                                </Tooltip>}
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.fromOrderNo}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('InboundPage.ASN Status')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {ASNArr.find(v => v.value === info?.asnState)?.label}
                                </MDTypography>
                            </MDBox>
                        </Grid>

                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('InboundPage.Execute State')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {executeStatusArr.find(v => v.value === info?.executeState)?.label}
                                </MDTypography>
                            </MDBox>
                        </Grid>

                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('InboundPage.OCP Process Status')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.processState}
                                </MDTypography>
                            </MDBox>
                        </Grid>

                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('InboundPage.WMS Process Status')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {asnWmsProcessStateArr.find(v => v.value === info?.wmsProcessState)?.label}
                                    {/*{info?.wmsProcessState}*/}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('InboundPage.Received State')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {receivedStateArr.find(v => v.value === info?.receivedState)?.label}
                                </MDTypography>
                            </MDBox>
                        </Grid>


                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('Warehouse Name')}:
                                </MDTypography>
                                {info?.warehouseName && <Tooltip title={t("Copy")} placement={'right'} onClick={()=> handleClickCopy(info?.warehouseName)}>
                                    <IconButton aria-label="copy" size="small" color="primary">
                                        <ContentCopyIcon fontSize="small"/>
                                    </IconButton>
                                </Tooltip>}
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.warehouseName}
                                </MDTypography>
                            </MDBox>
                        </Grid>


                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom>
                                    {t('Warehouse ID')}:
                                </MDTypography>
                                {info?.warehouseId && <Tooltip title={t("Copy")} placement={'right'} onClick={()=> handleClickCopy(info?.warehouseId)}>
                                    <IconButton aria-label="copy" size="small" color="primary">
                                        <ContentCopyIcon fontSize="small"/>
                                    </IconButton>
                                </Tooltip>}

                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.warehouseId}
                                </MDTypography>

                            </MDBox>
                        </Grid>

                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('InboundPage.Business Type Status')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {businessTypeArr.find(v => v.value === info?.businessType)?.label}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('InboundPage.Total Price')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.totalPrice}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('InboundPage.Total Weight (lb)')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.totalWeight}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('InboundPage.Total Volume (cube inch)')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.totalVolume}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('InboundPage.Total Quantity (EA)')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.totalQuantity}
                                </MDTypography>
                            </MDBox>
                        </Grid>

                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('InboundPage.ASN Time Created')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.asnCreationTime?convertTime(info?.addTime):''}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('InboundPage.Hang Status')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {hangStatusList.find(v => v?.value === info?.hangStatus)?.label}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('InboundPage.Expected Shipment Date')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.expectedShipmentTime?moment(info?.expectedShipmentTime).format('YYYY-MM-DD'):''}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('InboundPage.Order Due Date')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.orderDueDate?moment(info?.orderDueDate).format('YYYY-MM-DD'):''}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom>
                                    {t('InboundPage.Reference_1')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.asnReference1}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('InboundPage.Reference_2')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.asnReference2}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom>
                                    {t('InboundPage.Reference_3')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.asnReference3}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                    </Grid>
                </MDBox>
            </Collapse>

        </Card>
    </React.Fragment>)
}

export default InboundDetail